module.exports = __webpack_public_path__ + "green.8d6ec6c678a6243449b0.png";